import React from 'react'

export interface BillingPaginationProps {
  page: number
  totalPages: number
  handlePagination: (page: number) => void
}

export const BillingPagination = ({
  page,
  totalPages,
  handlePagination
}: BillingPaginationProps) => {
  console.log(`totalPages`, totalPages)
  return (
    <div className="flex flex-row justify-center w-full">
      {page > 1 ? (
        <div className="m-4">
          <button onClick={() => handlePagination(page - 1)} type="button">
            &lt;
          </button>
        </div>
      ) : (
        ''
      )}

      {page > 1 ? (
        <div className="m-4">
          <button onClick={() => handlePagination(1)} type="button">
            1
          </button>
        </div>
      ) : (
        ''
      )}

      {page > 3 ? <div className="text-center m-4">...</div> : ''}
      {page > 2 ? (
        <div className="text-center m-4">
          <button onClick={() => handlePagination(page - 1)} type="button">
            {page - 1}
          </button>
        </div>
      ) : (
        ''
      )}
      <div className="text-center m-4 font-bold">{page}</div>
      {page < totalPages - 1 ? (
        <div className="text-center m-4">
          <button onClick={() => handlePagination(page + 1)} type="button">
            {page + 1}
          </button>
        </div>
      ) : (
        ''
      )}
      {page < totalPages - 2 ? <div className="text-center m-4">...</div> : ''}

      {page < totalPages ? (
        <div className="m-4">
          <button onClick={() => handlePagination(totalPages)} type="button">
            {totalPages}
          </button>
        </div>
      ) : (
        ''
      )}

      {page < totalPages ? (
        <div className="m-4">
          <button onClick={() => handlePagination(page + 1)} type="button">
            &gt;
          </button>
        </div>
      ) : (
        ''
      )}
    </div>
  )
}

export default BillingPagination
